module.exports = __webpack_public_path__ + "static/media/main idea.bf11f2fc.mp3";